import { Dialog, DialogContent, DialogTitle, Link, TextField } from "@mui/material"
import { useTranslation } from "react-i18next"
import { UserCreateResultModel } from "services/openapi"
import "./UserCreateResultDialog.sass"

type Props = {
  open: boolean
  onClose: React.Dispatch<React.SetStateAction<boolean>>
  createResult: UserCreateResultModel
}

const UserCreateResultDialog = ({ open, onClose, createResult }: Props) => {
  const { t } = useTranslation()

  const bodytext = t("password-email.new-user-email-body", { userlogin: createResult.userLogin, firsttimepassword: createResult.firstTimePassword })
  const body = encodeURIComponent(bodytext)
  const href = `mailto:?subject=${t("password-email.subject-new-user")}&body=${body}`

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true}>
      <DialogTitle>{t("user-create.credentials")}</DialogTitle>
      <DialogContent id="user-credentials">
        <div id="result-dialog-inputs">
          <TextField
            id="userLogin"
            disabled={true}
            value={createResult.userLogin}
            label={t("user-create.userLogin")}
            variant="standard"
            color="primary"
          />
          <TextField
            id="firstTimePassword"
            disabled={true}
            value={createResult.firstTimePassword}
            label={t("user-create.password")}
            variant="standard"
            color="primary"
          />
        </div>
        <Link href={href}>{t("password-email.link-text")}</Link>
      </DialogContent>
    </Dialog>
  )
}

export default UserCreateResultDialog
